/*! tailwindcss v4.3.3 | MIT License | https://tailwindcss.com */
.notification-card {
  padding: calc(var(--spacing, 0.25rem) * 4);
  display: flex;
  flex-direction: column;
  width: calc(var(--spacing, 0.25rem) * 96);
  margin-top: calc(var(--spacing, 0.25rem) * 4);
  animation: slide-in 1s;
}
@keyframes slide-in {
  0% {
    transform: translateX(100%);
    opacity: 0;
  }
  100% {
    transform: translateX(0);
    opacity: 1;
  }
}
